import { Alert, AlertTitle, Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { Review } from '@marageti/z4-sdk/lib/travel/Review';

const TripMatchReviewPromptView = ({
  tripMatch,
  reviewPrompt,
} : {
  tripMatch: TripMatch,
  reviewPrompt: {
    show: boolean,
    emptyReview: Review | undefined,
  },
}) => (
  <Alert severity="info">
    <AlertTitle>We&apos;d love to hear your review</AlertTitle>
    How was your experience with
    {' '}
    {tripMatch.partnerName}
    ?
    {' '}
    Your feedback helps us improve our services for next travelers.

    <Button
      variant="contained"
      component={Link}
      to={{
        pathname: `/trip-matches/${tripMatch.id}/review`,
        search: reviewPrompt.emptyReview ? `?draft=${reviewPrompt.emptyReview.id}` : '',
      }}
    >
      Start Your Review
    </Button>
  </Alert>
);

export default TripMatchReviewPromptView;
